module.exports = "build/assets/RingsideWide-Semi.75ec04f4.ttf";